import React from "react";
import { Dropdown, ButtonGroup, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import useIsMobile from "@hooks/useIsMobile";

/**
 * Generic table toolbar actions:
 * - Primary action: Add (always visible)
 * - Secondary actions: shown inline if wide, moved into "⋯" dropdown if narrow
 */
export default function TableActions({
  onAdd,
  addLabelKey, // e.g. "button.add_tree" | "button.add_sensor"
  addTestId,
  collapseSecondary, // boolean (isNarrow)
  secondary = [], // array of React nodes (e.g. [<ImportTreeButton />])
}) {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const hasSecondary = secondary.filter(Boolean).length > 0;

  return (
    <>
      <Button
        variant="primary"
        size={isMobile ? "sm" : undefined}
        className={isMobile ? "px-2 py-1" : ""}
        onClick={onAdd}
        data-testid={addTestId}
        data-tour={addTestId === "add-tree-button" ? "tree-add-btn" : undefined}
      >
        + {isMobile ? "" : t(addLabelKey)}
      </Button>

      {!collapseSecondary ? (
        hasSecondary ? (
          <>{secondary}</>
        ) : null
      ) : hasSecondary ? (
        <Dropdown as={ButtonGroup} align="end">
          <Dropdown.Toggle variant="outline-primary">⋯</Dropdown.Toggle>
          <Dropdown.Menu>
            {secondary.filter(Boolean).map((node, idx) => (
              <Dropdown.Item key={idx} as="div" className="p-0">
                <div className="px-3 py-2">{node}</div>
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      ) : null}
    </>
  );
}
